import { useState } from "react";
import { last, nth } from "lodash";

export const useSummaryCheck = (cards) => {
  const [showSummary, setShowSummary] = useState(false);
  let summaryPresent = false;
  let summaryIndex = "none";

  if (cards) {
    if (last(last(cards)["story-elements"])?.subtype === "summary") {
      summaryPresent = true;
      summaryIndex = "last";
    } else if (last(last(cards)["story-elements"])?.metadata?.["promotional-message"] === true) {
      if (nth(last(cards)["story-elements"], -2)?.subtype === "summary") {
        summaryPresent = true;
        summaryIndex = "beforeLast";
      }
    }
  }

  return { summaryPresent, showSummary, setShowSummary, summaryIndex };
};
